import React from "react";

function CircleChevronLeftIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#fff"
        d="M12 0c6.61 0 12 5.39 12 12 0 6.656-5.39 12-12 12-6.656 0-12-5.344-12-12C0 5.39 5.344 0 12 0zm2.531 16.219L10.36 12l4.172-4.172c.61-.562.61-1.547 0-2.11a1.445 1.445 0 00-2.11 0l-5.25 5.25A1.454 1.454 0 006.75 12c0 .422.14.797.422 1.078l5.25 5.25c.562.61 1.547.61 2.11 0 .609-.562.609-1.547 0-2.11z"
      ></path>
    </svg>
  );
}

export default React.memo(CircleChevronLeftIcon);
